module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/061-saba-island-086a8435cc04168abe18916e07af6568.svg";